app.controller(
    'ConsultationDistrictController', ['$scope', '$rootScope', '$http', '$window', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'DistrictService', 'SideBarService', 'HelperService', 'ShareUrlService', '$sce', '$translate', '$state', 'ExplorerService', ConsultationDistrictController]
);

function ConsultationDistrictController($scope, $rootScope, $http, $window, $stateParams, $timeout, toastr, $document, Configuration, DistrictService, SideBarService, HelperService, ShareUrlService, $sce, $translate, $state, ExplorerService) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);
    $scope.quartier = {};
    $scope.edit = {};
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.IsCreatingNewDescriptionForDistrict = false;

    vm.quartier = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
    vm.ActiveDescriptionVm =
        {
            DescriptionNewPositionText: '1'
        };


    //Get Single 
    var promiseGetSingle = DistrictService.getDistrict($stateParams.id, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    promiseGetSingle.then(function (t) {
        var res = t.data;

        vm.quartier = res;

        if (vm.quartier.DescriptionList.length > 0) {
            if ($stateParams.descpos) {
                if ($stateParams.descpos > vm.quartier.DescriptionList.length) {
                    $stateParams.descpos = vm.quartier.DescriptionList.length;
                }
                vm.ActiveDescriptionId = $stateParams.descpos - 1;
            }
            else {
                vm.ActiveDescriptionId = 0;
            }
            vm.ActiveDescription = vm.quartier.DescriptionList[vm.ActiveDescriptionId].Description;
            vm.GetDescriptionVm();
        }


        $rootScope.PlaceList = res.PlaceList;
        $rootScope.CurrentObjectId = res.CurrentDisctrict.DistrictId;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.District;
        $rootScope.CurrentObjectStatus = res.CurrentDistrictStatus;
        $rootScope.Comments = res.CommentList;
        $rootScope.SideBar = res.SideBar;
        $rootScope.SideBar.CurrentObjectStatus = res.CurrentDistrictStatus;
        $rootScope.Clients = res.ClientList;
        $rootScope.ClassificationList = res.ClassificationList;
        $rootScope.SideBar.MesNotes = vm.quartier.District.MyNotes;

        $scope.GetAssociatedPlacesOnSideBar();
        vm.GetAssociatedFilesOnSideBar();
        //$scope.ChangeZoneById(vm.ParamZoneId);

        vm.StatusList4WorkflowDescriptionObj = angular.copy($rootScope.StatusList4WorkflowDescriptionSt);


    });


    $scope.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar($stateParams.id, 16, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces($stateParams.id, 16, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedFilesOnSideBar = function () {
        HelperService.GetAssociatedFilesOnSideBar($stateParams.id, $rootScope.EnumLinkType.District, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedFiles = data;
            });
    }

    $rootScope.DownloadAssociatedFile = function (name, $event) {
        $event.stopPropagation();
        var path = name;
        //path = 'test';
        //if ($stateParams.path !== undefined)
        //    path = $stateParams.path + "/" + name;
        ExplorerService.DownloadAssociatedFile(path, "application/pdf")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            }
            );

    };


    vm.UpdateDescriptionVm = function () {
        if (!vm.IsCreatingNewDescriptionForDistrict) {
            HelperService.UpdateDescriptionVm(vm.ActiveDescriptionVm, $rootScope.EnumLinkType.District)
            .then(
               function success(data) {
                   //recharge la page si la position du desc est modifié
                   if (vm.ActiveDescriptionVm.DescriptionCurrentPositionText != vm.ActiveDescriptionVm.DescriptionNewPositionText) {
                       window.location.reload();
                   }
               },
               function error(data) { });
        }
        else {
            vm.CreateNewDescriptionForDistrict();
        }
    }
    vm.PrepareCreateNewDescriptionForDistrict = function () {
        //add new desc local
        vm.IsCreatingNewDescriptionForDistrict = true;
        var newDescLocal = {};
        newDescLocal.DescriptionId = 0;
        vm.ActiveDescriptionVm.Description = {};
        vm.ActiveDescriptionVm.Description.DescriptionIcurrentd = 0;
        vm.ActiveDescriptionVm.Description.DescriptionTitle = '';
        vm.ActiveDescriptionVm.Description.Stick = '';
        vm.ActiveDescriptionVm.Description.Resume = '';
        vm.ActiveDescriptionVm.Description.Description = '';
        vm.ActiveDescriptionVm.DescriptionStatus = '';
        vm.ActiveDescriptionVm.Clients = [];
        vm.ActiveDescriptionVm.QualificationList = [];
        var lastIndex = vm.quartier.DescriptionList.push(newDescLocal) - 1;
        vm.ActiveDescriptionId = lastIndex;
    }

    vm.CreateNewDescriptionForDistrict = function () {
        //prepare data supplement
        var descForCreation = {};
        descForCreation.ObjectId = vm.quartier.District.DistrictId;
        descForCreation.CurrentLang = $scope.CurrentLang;
        descForCreation.LinkTypeId = $rootScope.EnumLinkType.District;
        descForCreation.DescriptionTranslation = vm.ActiveDescriptionVm.Description;
        descForCreation.DescriptionStatus = vm.ActiveDescriptionVm.DescriptionStatus;
        DistrictService.CreateNewDescriptionForDistrict(descForCreation)
        .then(
                function success(data) {
                    vm.IsCreatingNewDescriptionForDistrict = false;
                    vm.quartier.DescriptionList[vm.ActiveDescriptionId].Description = $rootScope.returnNewDesc;
                    $state.go('app.consultation.district', { id: vm.quartier.District.DistrictId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.quartier.DescriptionList.length });
                },
                function error(data) { });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/district?id=' + vm.quartier.District.DistrictId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }


    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.quartier.DescriptionList[vm.ActiveDescriptionId].DescriptionId, vm.quartier.District.DistrictId, $rootScope.EnumLinkType.District, 0, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionPosition(vm.quartier.District.DistrictId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.District);
        }
    }


    $scope.UpdateDistrict = function UpdateDistrict() {

        DistrictService.UpdateDistrict(vm.quartier, function (response) {

            if (response.success) {

                console.log("ok: ");
                vm.quartier = response;

            } else {
                console.log("error: ");
            }
        });
    };

    $scope.UpdateDescription = function UpdateDescription(index) {
        if (!vm.quartier.IsCreatingNewDescriptionForDistrict) {
            DistrictService.UpdateDescription(vm.quartier, function (response) {
                if (response.success) {
                    console.log("ok: ");
                    vm.quartier = response;
                } else {
                    console.log("error: ");
                }
            });
        }
        else
            $scope.CreateNewDescriptionForDistrict(index);
    };


    $scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {
        vm.quartier.DescriptionList[index].Description.StatusId = status;
        DistrictService.UpdateDescriptionStatus(vm.quartier, function (response) {

            if (response.success) {

                console.log("ok: ");
                vm.quartier = response;
            } else {
                console.log("error: ");
            }
        });
    };
    vm.PreviousDesc = function () {
        if (vm.quartier.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            $state.transitionTo('app.consultation.district', { id: vm.quartier.District.DistrictId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.quartier.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.quartier.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            $state.transitionTo('app.consultation.district', { id: vm.quartier.District.DistrictId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
        }
    }

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "District", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    // SideBar method

    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {

        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, 16);
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment(vm.quartier.SideBar.CommentEdit, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        SideBarService.SaveDiffuseur(vm.quartier.ClientList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        SideBarService.SaveAdressesAssociees(vm.quartier.PlaceList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        SideBarService.SaveClassification(vm.quartier.ClassificationList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };


    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareFicheComplete();
    }

    $rootScope.shareFicheComplete = function () {
        ShareUrlService.GenerateSharedUrl($stateParams.id, $rootScope.EnumLinkType.District, $rootScope.LangForWork)
            .then(function (data) {
                $rootScope.ShareUrlObj = data.data;
            },
            function (data) {
            }
        );
    }
};